import * as u from '@/util/util'
import * as c from '@/util/config'

// dict.js
export const zpresumeinfo001 = [
        {label: '是', value: '1'},
        {label: '否', value: '2'},
    ]

